import React, { useState } from "react";
import no_data_found from "../../assets/images/imgNo-removebg-preview.png";

export default function RecordNoImage(props) {
  const [delayTime, setDelayTime] = useState(false);

  console.log(props, "titletitletitle");

  return (
    <>
      <div className="no-access-string text-center">
        <div
          style={{
            display: "inline-block",
            padding: "10px",
          }}
        >
          <img
            className="no-data-image mx-auto"
            src={no_data_found}
            alt="No Data Found"
          />
        </div>

        {props.title ? (
          <p className=" text-center">{`${props.title}`}</p>
        ) : props.html ? (
          <div
            dangerouslySetInnerHTML={{
              __html: props.html,
            }}
          ></div>
        ) : (
          ""
        )}
      </div>
    </>
  );
}
